import { request } from 'tools'

export const getWorks = () => request.get( '/content/works.json' )
export const getWork = slug => request.get( `/content/works/${slug}.json` )